import React from 'react';

class ZCell extends React.Component {
    render() {
        let highlight = null;

        // Set highlight to 'on' if z-value is on either column or row and set highlight to 'target' if in both otherwise set it to 'off
        if (this.props.flag === 0) {
            highlight = "off";
        } else if (this.props.flag === 1) {    // Match onces and tenths place OR Hundredths place
            highlight = "on";
        } else if (this.props.flag === 2) {    // Match exactly
            highlight = "target";
        }

        // Build Cell with z-value data
        return (
            <td className={highlight}>
                {this.props.value.toFixed(4)}
            </td>
        );
    }
}

export default ZCell;